



































































































































































import AbpBase from "../../../lib/abpbase";
import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator';
import Util from '../../../lib/util'
import {GetRecipeData,Prescribe,DialysCheck,GetBeforeDialysCheck} from '../../../api/dialysisProcess'




@Component({
    components:{
    }
})
export default class  extends AbpBase{
    @Prop({type:Boolean,default:false}) value:boolean;
    @Prop({type:Object,default:{}}) data:any;

    created(){
      
    }
    piclist:any = {}
    picConfirm(){
        
    }
   
    //表单值
    rules = {};
    form:any = {
        recipeId:null,
        twlj:true,
        mfgl:true,
        jqcs:true,
        remarks:'',
    }
    async save(){
        if(!this.form.twlj || !this.form.mfgl || !this.form.jqcs){
            this.$Message.info('请正确核对项目')
            return false
        }
        this.form.recipeId = this.data.recipeId
        let res  = await DialysCheck(this.form)
        if(res.status==1){
            this.$emit('input',false);
            this.$emit('on-back')
        }
    }


    //确认处方
   
    mounted() {
        this.getBeforeDialysCheck()
    }
    diyInfo:any = {}
    async getBeforeDialysCheck(){
        let data = {
            DialysisSignId:this.data.dialysisSignId,
        }
        let res = await GetBeforeDialysCheck(data)
        this.diyInfo = res.objects
        console.log(res)
    }
    antiWaysColumn = [
        {
            key:'antiWays',
            title:'抗凝方式',
        },{
            key:'medName',
            title:'抗凝药品',
        },{
            key:'antiFirstDose',
            title:'首剂',
        },{
            key:'antiFirstUnit',
            title:'首剂单位',
        },{
            key:'antiAddDose',
            title:'追加/小时',
        },{
            key:'dose',
            title:'枸橼酸剂量(ml/h)',
        },{
            key:'gaMedName',
            title:'钙剂药品',
        },{
            key:'gaDose',
            title:'钙剂剂量',
        },{
            key:'normalSalineMedName',
            title:'生理盐水药品',
        },{
            key:'normalSalineDose',
            title:'生理盐水剂量',
        },{
            key:'pumpDose',
            title:'泵 入',
        }
    ]
    
    cancel(){
        // (this.$refs.roleForm as any).resetFields();
        this.$emit('input',false);
    }
    visibleChange(value:boolean){
        if(!value){
            this.$emit('input',value);
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/dialysisProcess/dialysisArea/crosscheck.vue